module.exports = __webpack_public_path__ + "img/en-pc-s6.132e1aad.png";